// @flow
import update from 'immutability-helper';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { setNewAlert } from '../../alert/duck';
import { endpoints, getPurchaseApi } from './api';

import type { Observable } from 'rxjs';
import type { Order } from '../../../entities';
import type { HTTPError } from '../../../error';

export type CheckoutSuccessStepAction = {
  +type: string;
  +order?: Order;
  +idOrder?: string;
  +error?: HTTPError;
};

export type CheckoutSuccessStepState = {
  +order?: Order;
  +error?: HTTPError;
  +isFetchingOrder?: boolean;
  +fetchOrderError?: HTTPError;
};

const CHECKOUT_SUCCESS_STEP_FILL_ORDER = 'CHECKOUT_SUCCESS_STEP_ORDER_FILL';
const CHECKOUT_SUCCESS_STEP_RESET_STATE = 'CHECKOUT_SUCCESS_STEP_RESET_STATE';

const CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST = 'CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST';
const CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS = 'CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS';
const CHECKOUT_SUCCESS_FETCH_ORDER_ERROR = 'CHECKOUT_SUCCESS_FETCH_ORDER_ERROR';

export function fillOrder(order: Order): CheckoutSuccessStepAction {
  return {
    type: CHECKOUT_SUCCESS_STEP_FILL_ORDER,
    order,
  };
}

export function resetState(): CheckoutSuccessStepAction {
  return {
    type: CHECKOUT_SUCCESS_STEP_RESET_STATE,
  };
}

export function fetchOrder(idOrder: string): CheckoutSuccessStepAction {
  return {
    type: CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST,
    idOrder,
  };
}

export function fetchOrderSuccess(order: Order): CheckoutSuccessStepAction {
  return {
    type: CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS,
    order,
  };
}

export function fetchOrderErrorFn(error: HTTPError): CheckoutSuccessStepAction {
  return {
    type: CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS,
    error,
  };
}

export const actions = {
  CHECKOUT_SUCCESS_STEP_RESET_STATE,
  CHECKOUT_SUCCESS_STEP_FILL_ORDER,
  CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST,
  CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS,
  CHECKOUT_SUCCESS_FETCH_ORDER_ERROR,
  resetState,
  fillOrder,
  fetchOrder,
  fetchOrderSuccess,
  fetchOrderErrorFn,
};

export const initialState: CheckoutSuccessStepState = {};

export default function reducer(state: CheckoutSuccessStepState = initialState,
                                action: CheckoutSuccessStepAction): CheckoutSuccessStepState {
  switch (action.type) {
    case CHECKOUT_SUCCESS_STEP_FILL_ORDER:
      return update(state, {
        order: { $set: action.order },
      });
    case CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST:
      return update(state, {
        isFetchingOrder: { $set: true },
      });
    case CHECKOUT_SUCCESS_FETCH_ORDER_SUCCESS:
      return update(state, {
        $unset: ['isFetchingOrder'],
        order: { $set: action.order },
      });
    case CHECKOUT_SUCCESS_FETCH_ORDER_ERROR:
      return update(state, {
        $unset: ['isFetchingOrder'],
        fetchOrderError: { $set: action.error },
      });
    case CHECKOUT_SUCCESS_STEP_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function checkoutSuccessFetchOrderEpic(action$: Observable<CheckoutSuccessStepAction>): Observable<CheckoutSuccessStepAction> {
  return action$.pipe(
    ofType(CHECKOUT_SUCCESS_FETCH_ORDER_REQUEST),
    mergeMap(({ idOrder }) => {
      return getPurchaseApi(undefined, {
        route: endpoints.GET_PURCHASE.replace(':id', idOrder),
      }).pipe(
        map((order: Order) => fetchOrderSuccess(order)),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(fetchOrderErrorFn(e));
          }
          return of(fetchOrderErrorFn(e));
        }));
    }));
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutSuccessStep/duck.js